import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-fileaudit',
  templateUrl: './fileaudit.component.html',
  styleUrls: ['./fileaudit.component.css']
})
export class FileauditComponent implements OnInit {
  respObject: any;
  resultData: any;
  compObj: any;
  compData: any;

  dataType = "";
  fileYear="";
  fullYear: number = new Date().getFullYear();
  yearArr= [];
  yearfArr= [];
  filefYear="";
  selectMonth="";
  fileQuarter="";
  companyId="";
  downLoadPath=this._rest.FILE_PATH;

  perPageRow = this._rest.PER_PAGE_ROW;
  curPage = 1;
  totalRows = 0;
  pages = [];
  noOfRows = 0;
  offset = this._rest.PER_PAGE_ROW;

  constructor(@Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,private router: Router, private _rest: RestapiService) {}

  ngOnInit(): void {
    this.dataType = "";
    this.selectMonth="";
    this.fileQuarter="";
    this.curPage= 1;
    this.companyId="";
    for (var i= this.fullYear-10;i<=this.fullYear;i++){
      this.yearArr.push(i);
    }
    for (var i= this.fullYear-10;i<=this.fullYear;i++){
      this.yearfArr.push(i+"-"+(i+1));
    } 
    const cRData = {}
    this._rest.companyList(cRData).subscribe((res) => {
      this.compObj = res;
      this.compData = this.compObj.details;      
    });   
    this.searchFile(1);
  }
  godetails(url){
  	this.router.navigate([url]);
  }

  next() {
    if(this.resultData.length > 0) {
      this.offset = this.offset + this.perPageRow;
      this.curPage = this.offset / this.perPageRow;
      this.searchFile(this.curPage);
    }
  }
  previous() {
    if (this.curPage > 0) {
      this.offset = this.offset - this.perPageRow;
      this.curPage = this.offset / this.perPageRow;
      this.searchFile(this.curPage);
    }
  }

  searchFile(curPage){
    this.curPage = curPage;
    var fd = {};
    fd["limit"]=this.perPageRow;
    fd["page"]=this.curPage;
    fd["templateType"]=this.dataType;
    if(this.dataType == "Segment"){
      fd["year"]=this.fileYear;
      fd["monthly"]=this.selectMonth;
    } else if(this.dataType == "Form" || this.dataType == "Financial Highlights" || this.dataType == "Data on Motor" || this.dataType == "Reinsurance" ){     
      fd["year"]=this.filefYear;
      fd["quarterly"]=this.fileQuarter;
    } else if(this.dataType == "Gross & Net Statistics" || this.dataType == "Large Loss"){     
      fd["year"]=this.filefYear;
    }
    if(this.companyId!=""){
      fd["companyId"]=this.companyId;
    }
    //console.log(fd);
    this._rest.getFileAudit(fd).subscribe((res) => {
      this.respObject = res;
      
      if(this.respObject.error==0){
        this.resultData=this.respObject.resp.data;
        this.totalRows = this.respObject.resp.info;
        this.noOfRows=this.respObject.resp.data.length;
        this.pages=[];
        for (var i=1;i<=Math.ceil(this.totalRows/this.perPageRow);i++){
          this.pages.push(i);
        }
      } else {
        this.resultData=[];
        this.totalRows = 0;
        this.noOfRows = 0;
        this.pages=[];
      }
    })
  }
}
